export const ESIM_SEND_QR_EMAIL = "ESIM_SEND_QR_EMAIL";
export const ESIM_VERIFY_CODE = "ESIM_VERIFY_CODE";
